import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const PhonesList = React.lazy(() => import('../components/PhonesList'));
function FakeServiceListView(props: Object) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <PhonesList {...props} />
    </Suspense>
  );
}

export default FakeServiceListView;
